export function reportErrorToConsole(error: unknown) {
  // eslint-disable-next-line no-console
  console.error(error)
}
